import { EPageName } from "@/util/enum";

export const getBreakpoints = (pageName: string, spaceBetween = 10) => {
    if (pageName === EPageName.BANNER) {
        const defaultSlides = 1;
        return {
            300: { slidesPerView: defaultSlides, spaceBetween },
            640: { slidesPerView: defaultSlides, spaceBetween },
            991: { slidesPerView: defaultSlides, spaceBetween },
            1024: { slidesPerView: defaultSlides, spaceBetween },
            1280: { slidesPerView: defaultSlides, spaceBetween },
            1360: { slidesPerView: defaultSlides, spaceBetween },
            1440: { slidesPerView: defaultSlides, spaceBetween },
            1680: { slidesPerView: defaultSlides, spaceBetween },
        };
    }
    else if (pageName === EPageName.TWOSLIDE) {
        const defaultSlides = 2;
        return {
            300: { slidesPerView: 1, spaceBetween },
            640: { slidesPerView: 1, spaceBetween },
            991: { slidesPerView: defaultSlides, spaceBetween },
            1024: { slidesPerView: defaultSlides, spaceBetween },
            1280: { slidesPerView: defaultSlides, spaceBetween },
            1360: { slidesPerView: defaultSlides, spaceBetween },
            1440: { slidesPerView: defaultSlides, spaceBetween },
            1680: { slidesPerView: defaultSlides, spaceBetween },
        };
    }
    else if (pageName === EPageName.SLIDER) {
        const defaultSlides = 2;
        return {
            300: { slidesPerView: 1, spaceBetween },
            640: { slidesPerView: defaultSlides, spaceBetween },
            991: { slidesPerView: defaultSlides, spaceBetween },
            1024: { slidesPerView: defaultSlides, spaceBetween },
            1280: { slidesPerView: defaultSlides, spaceBetween },
            1360: { slidesPerView: defaultSlides, spaceBetween },
            1440: { slidesPerView: defaultSlides, spaceBetween },
            1680: { slidesPerView: defaultSlides, spaceBetween },
        };
    }
    else if (pageName === EPageName.THREESLIDE) {
        const defaultSlides = 3;
        return {
            300: { slidesPerView: 1.2, spaceBetween },
            640: { slidesPerView: 2.2, spaceBetween },
            991: { slidesPerView: 2.2, spaceBetween },
            1024: { slidesPerView: defaultSlides, spaceBetween },
            1280: { slidesPerView: defaultSlides, spaceBetween },
            1360: { slidesPerView: defaultSlides, spaceBetween },
            1440: { slidesPerView: defaultSlides, spaceBetween },
            1680: { slidesPerView: defaultSlides, spaceBetween },
        };
    }
    else if (pageName === EPageName.FOURSLIDE) {
        const defaultSlides = 4;
        return {
            300: { slidesPerView: 1, spaceBetween },
            640: { slidesPerView: 1, spaceBetween },
            991: { slidesPerView: 2, spaceBetween },
            1024: { slidesPerView: defaultSlides, spaceBetween },
            1280: { slidesPerView: defaultSlides, spaceBetween },
            1360: { slidesPerView: defaultSlides, spaceBetween },
            1440: { slidesPerView: defaultSlides, spaceBetween },
            1680: { slidesPerView: defaultSlides, spaceBetween },
        };
    }
    else if (pageName === EPageName.FIVESLIDE) {
        const defaultSlides = 5;
        return {
            300: { slidesPerView: 1.2, spaceBetween },
            640: { slidesPerView: 2, spaceBetween },
            991: { slidesPerView: 4, spaceBetween },
            1024: { slidesPerView: defaultSlides, spaceBetween },
            1280: { slidesPerView: defaultSlides, spaceBetween },
            1360: { slidesPerView: defaultSlides, spaceBetween },
            1440: { slidesPerView: defaultSlides, spaceBetween },
            1680: { slidesPerView: defaultSlides, spaceBetween },
        };
    }
    else if (pageName === EPageName.CLIENTAWARD) {
        const defaultSlides = 7;
        return {
            300: { slidesPerView: 3, spaceBetween },
            640: { slidesPerView: 3, spaceBetween },
            991: { slidesPerView: 4, spaceBetween },
            1024: { slidesPerView: defaultSlides, spaceBetween },
            1280: { slidesPerView: defaultSlides, spaceBetween },
            1360: { slidesPerView: defaultSlides, spaceBetween },
            1440: { slidesPerView: defaultSlides, spaceBetween },
            1680: { slidesPerView: defaultSlides, spaceBetween },
        };
    }
    else if (pageName === EPageName.TRUSTEDVOICE) {
        const defaultSlides = 4;
        return {
            300: { slidesPerView: 1.5, spaceBetween: 12, centeredSlides: true },
            640: { slidesPerView: 2.5, spaceBetween: 14, centeredSlides: true },
            991: { slidesPerView: defaultSlides, spaceBetween },
            1024: { slidesPerView: defaultSlides, spaceBetween },
            1280: { slidesPerView: defaultSlides, spaceBetween },
            1360: { slidesPerView: defaultSlides, spaceBetween },
            1440: { slidesPerView: defaultSlides, spaceBetween },
            1680: { slidesPerView: defaultSlides, spaceBetween },
        };
    }
    else if (pageName === EPageName.LASERHAIRPACKAGE) {
        const defaultSlides = 4;
        return {
            300: { slidesPerView: 1, spaceBetween: 1, centeredSlides: true },
            640: { slidesPerView: 1, spaceBetween: 1, centeredSlides: true },
            991: { slidesPerView: defaultSlides, spaceBetween },
            1024: { slidesPerView: defaultSlides, spaceBetween },
            1280: { slidesPerView: defaultSlides, spaceBetween },
            1360: { slidesPerView: defaultSlides, spaceBetween },
            1440: { slidesPerView: defaultSlides, spaceBetween },
            1680: { slidesPerView: defaultSlides, spaceBetween },
        };
    }
    else if (pageName === EPageName.AWARDS) {
        const defaultSlides = 4;
        return {
            300: { slidesPerView: 1.5, spaceBetween: 12, centeredSlides: true },
            640: { slidesPerView: 1.5, spaceBetween: 14, centeredSlides: true },
            991: { slidesPerView: 2, spaceBetween, centeredSlides: true },
            1024: { slidesPerView: 2, spaceBetween },
            1280: { slidesPerView: defaultSlides, spaceBetween },
            1360: { slidesPerView: defaultSlides, spaceBetween },
            1440: { slidesPerView: defaultSlides, spaceBetween },
            1680: { slidesPerView: defaultSlides, spaceBetween },
        };
    }
    else {
        const defaultSlides = 4.2;
        return {
            300: { slidesPerView: 2.2, spaceBetween },
            640: { slidesPerView: 2.2, spaceBetween },
            991: { slidesPerView: 2.2, spaceBetween },
            1024: { slidesPerView: 3.2, spaceBetween },
            1280: { slidesPerView: 3.2, spaceBetween },
            1360: { slidesPerView: defaultSlides, spaceBetween },
            1440: { slidesPerView: defaultSlides, spaceBetween },
            1680: { slidesPerView: defaultSlides, spaceBetween },
        };
    }
};
